import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Provider, useDispatch } from "react-redux";
import { Toaster } from "react-hot-toast";
import "./App.css";
import store from "./store/store";
import { fetchCurrentUser } from "./store/authSlice";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Register from "./pages/Register";
import About from "./pages/about/About";
import Feedback from "./pages/feedback/Feedback";
import Contact from "./pages/contact/Contact";
import PotholeDetails from "./pages/potholeDetails/PotholeDetails";
import Report from "./pages/report/Report";
import AllPotholes from "./pages/allPotholes/AllPotholes";

function AppBootstrap({ children }) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCurrentUser());
  }, [dispatch]);

  return children;
}

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <AppBootstrap>
          <Navbar />
          <div className="min-h-screen flex flex-col">
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/pothole/:id" element={<PotholeDetails />} />
                <Route path="/about" element={<About />} />
                <Route path="/feedback" element={<Feedback />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/potholes" element={<AllPotholes />} />
                <Route
                  path="/report"
                  element={
                    <ProtectedRoute>
                      <Report />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </main>
            <Footer />
          </div>
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 3000,
              style: {
                background: "#0b1f44",
                color: "#fff",
                fontFamily: "Outfit, sans-serif",
              },
            }}
          />
        </AppBootstrap>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
